var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLock({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 15,
    viewBox: "0 0 11 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 6.50001C11 5.76401 10.384 5.16667 9.625 5.16667H8.9375V3.83334C8.9375 1.99267 7.39819 0.5 5.50001 0.5C3.60181 0.5 2.0625 1.99267 2.0625 3.83334V5.16667H1.375C0.616006 5.16667 0 5.76401 0 6.50001V13.1667C0 13.9027 0.616006 14.5 1.375 14.5H9.625C10.384 14.5 11 13.9027 11 13.1667V6.50001ZM3.4375 3.83438C3.4375 2.72981 4.36088 1.83438 5.5 1.83438C6.63911 1.83438 7.56249 2.72981 7.56249 3.83438V5.16771H3.4375V3.83438Z",
    fill: "#1A1A1A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLock);
export default __webpack_public_path__ + "static/media/icon_lock.0c144c2247872286ca17bb0dda34c2f9.svg";
export { ForwardRef as ReactComponent };